document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-7vn-home-header]');
  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 36);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const panel = document.querySelector('[data-7vn-mobile-panel]');
  const toggles = document.querySelectorAll('[data-7vn-menu-toggle]');
  const mobileQuery = window.matchMedia('(max-width: 980px)');
  const setMenu = (open) => {
    if (!panel) return;
    const shouldOpen = Boolean(open && mobileQuery.matches);
    panel.hidden = !shouldOpen;
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(shouldOpen)));
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => setMenu(panel ? panel.hidden : true));
  });

  mobileQuery.addEventListener('change', () => setMenu(false));
  setMenu(false);

  document.querySelectorAll('.mobile-panel a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 104, behavior: 'smooth' });
    });
  });

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('.main-product-image img');
    const thumbs = gallery.querySelectorAll('[data-netlify-thumb]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const thumbImage = thumb.querySelector('img');
        if (!thumbImage) return;
        mainImage.src = thumbImage.currentSrc || thumbImage.src;
        if (thumbImage.srcset) mainImage.srcset = thumbImage.srcset;
        if (thumbImage.alt) mainImage.alt = thumb.getAttribute('aria-label') || thumbImage.alt;
        thumbs.forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  const stickyCta = document.querySelector('[data-sevenvn-sticky-cta]');
  const stickyTrigger = document.querySelector('[data-sevenvn-sticky-trigger]');
  if (stickyCta && stickyTrigger) {
    const stopTargets = Array.from(document.querySelectorAll('#waitlist, .site-footer, footer'));
    let ticking = false;

    const updateStickyCta = () => {
      const triggerRect = stickyTrigger.getBoundingClientRect();
      const pastHero = triggerRect.bottom <= 0;
      const reachedStop = stopTargets.some((target) => {
        const rect = target.getBoundingClientRect();
        return rect.top <= window.innerHeight - 24 && rect.bottom > 0;
      });

      stickyCta.classList.toggle('visible', pastHero && !reachedStop);
      ticking = false;
    };

    const requestStickyUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyCta);
    };

    updateStickyCta();
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
  }
});
